import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ContactCardInterface } from "src/app/core/interfaces/contact-card-interface";
import { MobilityContactCardInterface } from "src/app/core/interfaces/mobility-contact-card-interface";
import { FavoriteContactInterface } from "src/app/core/interfaces/favorite-contact-interface";
import { FilterSet, FilterSetLight } from "src/app/core/interfaces/filter-interface";
import { BackendService } from "src/app/core/services/backend-service";

@Injectable({
  providedIn: "root",
})
export class MobilityRefService extends BackendService {
  getMobilityRefs(
    selectedFilters: FilterSet[]
  ): Promise<MobilityContactCardInterface[]> {
    return this.post<FilterSet[], MobilityContactCardInterface[]>(
      "api/mobilityref-contacts",
      selectedFilters
    );
  }

  getMobilityRefsForJourney(
    selectedFilters: FilterSetLight[]
  ): Promise<MobilityContactCardInterface[]> {
    return this.post<FilterSetLight[], MobilityContactCardInterface[]>(
      "api/mobilityref-contacts/journey",
      selectedFilters
    );
  }

  deleteManyMobilityRefsFavorite(
    toRemoveFromFavorite: string[]
  ): Promise<void> {
    const params = undefined;
    return this.delete<void>("api/mobilityref-contacts", params, toRemoveFromFavorite);
  }

  postManyMobilityRefsFavorite(
    toAddToFavorite: ContactCardInterface[]
  ): Promise<FavoriteContactInterface[]> {
    const body = toAddToFavorite
      .filter((x) => x.spId !== undefined)
      .map((x) => x.spId!.toString());
    return this.post<string[], FavoriteContactInterface[]>(
      "api/mobilityref-contacts/favorites",
      body
    );
  }

  getIsMobilityContactFavorite(contact: ContactCardInterface) {
    const params = new HttpParams().append(
      "contactSpId",
      String(contact.spId ?? 0)
    );
    return this.get<boolean>("api/mobilityref-contacts/is_favorite", params);
  }
}
